import { api } from '../utils/apiClient';

export const segmentService = {
  async getAll() {
    return api.get('/segments');
  },

  async getById(id) {
    return api.get('/segments/' + id);
  },

  async create(segment) {
    return api.post('/segments', segment);
  },

  async update(id, segment) {
    return api.put('/segments/' + id, segment);
  },

  async remove(id) {
    return api.del('/segments/' + id);
  },

  // conditions/matchType already in backend condition JSON shape — see
  // utils/segmentConditions.js for the UI-filter -> condition translation.
  async previewConditions(conditions, matchType) {
    return api.post('/segments/preview', { conditions, match_type: matchType || 'ALL' });
  },

  async previewSaved(id) {
    return api.post('/segments/' + id + '/preview');
  },

  // { name, sample_values }[] discovered live from ClickHouse — no stored
  // catalog, since any event can carry any property.
  async getEventProperties(table, eventName) {
    return api.get('/segments/event-properties', { table, event_name: eventName });
  },
};
